import React, {Component} from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import Select from "react-select";
import InsuranceCompany from "../../models/InsuranceCompany";
import InsurancePolicy from "../../models/InsurancePolicy";
import {NotificationContext} from "../contexts/NotificationContext";
import ability from "../../Ability";
import {Redirect, withRouter} from "react-router-dom";
import * as Paths from "../../config/paths";
import Error from "../Error";

import {IoIosSave, IoMdClose} from 'react-icons/io'
import ClientCompany from "../../models/ClientCompany";
import { handleResponseError } from '../../service/errorHandlingService';

class NewPolicy extends Component{

    static contextType = NotificationContext;

    constructor(props){
        super(props);

        this.state = {
            clientCompany: props.location.clientCompany || null,
            selectedInsuranceCompany: null,
            policyNumber: null,
            insuranceCompaniesSelectList: [],
            errorResponse: null
        };

        this.updatePolicyNumber = this.updatePolicyNumber.bind(this);
        this.updateSelectedInsuranceCompany = this.updateSelectedInsuranceCompany.bind(this);
        this.createPolicy = this.createPolicy.bind(this);
    }

    componentWillMount() {
        this.getInsuranceCompanies();

        if (!this.props.policy){
            let {id} = this.props.match.params;

            this.getClientCompany(id);
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps !== this.props){
            let {id} = nextProps.match.params;

            this.getClientCompany(id);
        }
    }

    getClientCompany(id){
        ClientCompany.getClientCompany(id)
            .then(response => {
                if (response.status === 200){
                    let clientCompany = new ClientCompany(response.body);

                    this.setState({
                        clientCompany: clientCompany,
                        errorResponse: null
                    });
                }
            })
            .catch(err => {
                this.setState({
                    errorResponse: err.response
                });

                handleResponseError(err, [
                    {
                        status: 404,
                        message: "Der Kunde wurde nicht gefunden"
                    },
                ])
            });
    }

    getInsuranceCompanies(){
        InsuranceCompany.getInsuranceCompanies()
            .then(response => {
                if (response.status === 200){
                    let insuranceCompanies = response.body;

                    let insuranceCompaniesSelectList = [];

                    for (let insuranceCompany of insuranceCompanies){
                        if (insuranceCompany){
                            insuranceCompaniesSelectList.push({
                                label: insuranceCompany.name,
                                value: insuranceCompany
                            });
                        }
                    }

                    this.setState({
                        insuranceCompaniesSelectList: insuranceCompaniesSelectList
                    });
                }
            })
            .catch(err => {
                this.context.showMessage(null, "Fehler beim Laden der Versicherungen", "danger");
            });
    }

    updatePolicyNumber(event){
        this.setState({
            policyNumber: event.target.value
        });
    }

    updateSelectedInsuranceCompany(selectedOption){
        this.setState({
            selectedInsuranceCompany: selectedOption.value
        });
    }

    _handlePolicyErrors(err){
        const jsonErrors = JSON.parse(err.response.text).errors

        handleResponseError(err, [
            {
                status: 404,
                message: "Die Versicherung wurde nicht gefunden"
            },
            {
                status: 409,
                message: `Die Vertragsnummer ist bei ${jsonErrors} angelegt`
            },
        ])
    }

    createPolicy(event){
        event.preventDefault();

        let policy = new InsurancePolicy({
            insurance_company_id: this.state.selectedInsuranceCompany.id,
            policy_number: this.state.policyNumber
        });

        policy.createPolicy(this.state.clientCompany.id)
            .then(response => {
                if (response.status === 201){
                    this.context.showMessage(null, "Police erstellt", "success");
                    this.props.history.goBack();
                }
                else{
                    this.context.showMessage(null, "Unbekannter Fehler", "danger");
                }
            })
            .catch(err => {
                this._handlePolicyErrors(err);
            });
    }

    render(){
        if (ability.cannot("create", "InsurancePolicy")){
            return <Redirect to={Paths.PATH_ROOT}/>
        }

        if (this.state.errorResponse){
            return <Error
                status={this.state.errorResponse.status}
                statusText={this.state.errorResponse.statusText}/>
        }

        if (!this.state.clientCompany){
            return  null;
        }

        return(
            <div className={"fimo-content-page"}>
                <div className={"row fimo-background"} style={{maxWidth: "100%", margin: "0px"}}>
                    <div className="col text-right" style={{maxWidth: "100%"}}>
                        <button className="btn btn-outline-form"
                                onClick={this.createPolicy}>
                            <div>
                                <IoIosSave/>
                            </div>
                            Speichern
                        </button>
                        <button className="btn btn-outline-form"
                                type="button"
                                onClick={() => this.props.history.goBack()}>
                            <div>
                                <IoMdClose style={{color: " red"}}/>
                            </div>
                            Abbrechen
                        </button>
                    </div>
                </div>
                <div style={{padding: "30px"}}>
                    <div>
                        <h4>Neue Policy anlegen</h4>
                    </div>
                    <div className={"row"}>
                        <form>
                            <div className="form-row">
                                <label className="col-form-label" style={{width: "200px"}}>
                                    <b>Versicherer:</b>
                                </label>

                                <Select
                                    className="col"
                                    options={this.state.insuranceCompaniesSelectList}
                                    ref={(input) => {this.clientInput = input;}}
                                    style={{maxWidth: "250px", minWidth: "130px"}}
                                    default=""
                                    autoFocus={true}
                                    onChange={this.updateSelectedInsuranceCompany}/>
                            </div>

                            <div className="form-row">
                                <label className="col-form-label" style={{width: "200px"}}>
                                    <b>Vertragsnummer (*):</b>
                                </label>

                                <input className="col form-control"
                                       value={this.state.policyNumber}
                                       style={{marginLeft: "5px", marginRight: "5px"}}
                                       onChange={this.updatePolicyNumber}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }

}

export default withRouter(NewPolicy);